import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

let lang = localStorage.lang;

export default {
    state: {
        // ******* 首页 ***************
        // 
        // 首页商品
        firstList: [],
        firstCate: [],
        secondList: [],
        secondCate: [],
        thirdList: [],
        thirdCate: [],
        fourthList: [],
        fourthCate: [],
        fifthList: [],
        fifthCate: [],
		successively:'asc',//顺序
        // 
        // ******* 列表页 ***************
        // 
        // 面包屑导航参数
        breadCrumb: [],
        brandId: "",
        brandName: "",

        subcate: [],// 子类列表
        brand: [],// 品牌信息

        goods_list: [], // 商品列表
        // 页码参数
        currentPage: 1, // 当前页数
        pageSize: 1, // 当前页数量
        pageSizes: [], // 可选择显示条数
        pageCount: 1, // 总页数
		goods_per_page:0,//我的收藏每条页数
		goods_total:0,//我的收藏总页数
	
        // 
        // ********* 详情页 *************
        // 
        goods: {}, // 商品数据
        spec_attr: [], // 规格属性
        color_attr: [], // 颜色属性
        personal: {}, // 个人数据

        price: null, // 价格
        unit: null, // 单位
        mdImg: null, // 中图片地址

        selected_spec: null, // 选中规格
        selected_color: null, // 选中颜色
        // 
        // ********* 首页管理 *************
        // 
        center_mian_goods: [], // 首页管理-我的商品
        // 
        // ********* 我的商品 *************
        // 
        user_goods: [], // 我的商品
		per_page:0,// 我的商品每一页多少条数据
        total: 0, // 我的商品总数
		commodityPage:{
			current_page:1,
			data:[],
			last_page:1,
			per_page:1,
			total:1
		},//我的商品數組
        // 
        // ********* 收藏夹 *************
        // 
        collection_goods: [], // 我的收藏
    },
    mutations: {
        // ********* 首页 *****************
        // 
        setMainGoods(state, arg){ // 写入首页商品
            let { goods, cate } = arg;
            // 判断是否需要添加前缀
            for(var item of goods){
                for(var val of item){
                    let newImgs = [];
                    newImgs=val.goods_images.split(",");
                    for(var i in newImgs){
                        if(newImgs[i].indexOf('http')<0){
                            newImgs[i]=URL.imgUrl+newImgs[i];
                        }
                    }
                    val.goods_images = newImgs;
                }
            }
            // 判断是否需要添加前缀
            for(var item of cate){
                if(item.image && item.image.indexOf('http')<0){
                    item.image=URL.imgUrl+item.image;
                }
            }
            // 列表写入
            state.firstList = goods[0];
            state.secondList = goods[1];
            state.thirdList = goods[2];
            state.fourthList = goods[3];
            state.fifthList = goods[4];
            // 分类写入
            state.firstCate = cate[0];
            state.secondCate = cate[1];
            state.thirdCate = cate[2];
            state.fourthCate = cate[3];
            state.fifthCate = cate[4];
        },
        changeSecondList(state, arg){ // 修改第二列表数据
            state.secondList = arg;
        },
        changeThirdList(state, arg){ // 修改第三列表数据
            state.thirdList = arg;
        },
        changeFourthList(state, arg){ // 修改第四列表数据
            state.fourthList = arg;
        },
        clearSecondList(state){ // 清除第二列数据
            state.secondList = [];
        },
        clearThirdList(state){ // 清除第三列数据
            state.thirdList = [];
        },
        clearFourthList(state){ // 清除第四列数据
            state.fourthList = [];
        },
        // 
        // ********* 列表页 *************
        // 
        setBreadCrumb(state, arg){ // 写入面包屑导航
            state.breadCrumb = arg;
        },
        clearBreadCrumb(state){ // 清空面包屑导航
            state.breadCrumb = [];
        },
        setSubcate(state, arg){ // 写入子类列表
            state.subcate = arg;
        },
        setBrand(state, arg){ // 写入品牌
            state.brand = arg
        },
        clearSubcateBrand(state){ // 清除子类列表 & 品牌
            state.subcate = [];
            state.brand = []
        },
        setPlist(state, arg){ // 写入商品列表内容
            let { brand_id, brand_name, list } = arg;
            let { data, current_page, per_page, last_page } = list;
			// console.log('查看',arg.list)
            for(let item of data){ // 判断是否需要添加前缀
                let newImgs = [];
                newImgs=item.goods_images.split(",");
                for(let i in newImgs){
                    if(newImgs[i].indexOf('http')<0){
                        newImgs[i]=URL.imgUrl+newImgs[i];
                    }
                }
                item.goods_images = newImgs
            }
			state.commodityPage = arg.list;
            state.brandId = brand_id;
            state.brandName = brand_name;
            state.goods_list = data;
            state.currentPage = current_page;
            state.pageSize = parseInt(per_page);
            state.pageCount = last_page;
        },
        setPageSizes(state, arg){ // 写入页码数组
            state.pageSizes = arg;
        },
        clearPlist(state){ // 清空商品页数据
            state.brandId = "";
            state.brandName = "";
            state.goods_list = [];
            state.currentPage = 1;
            state.pageSize = 1;
            state.pageSizes = [];
            state.pageCount = 1;
        },
        changePlistCollection(state, arg){ // 修改商品收藏状态
            for(let item of state.goods_list){
                if(item.goods_id == arg.id){
                    item.collection = arg.status;
                }
            }
        },
        // 
        // ********* 详情页 *************
        // 
        setPdetail(state, arg){ // 写入获取参数
            let { good, personal, attr1, attr3 } = arg;
            // 补充图片地址
            if(!!good.goods_images){
                let newImgs = [];
                newImgs = good.goods_images.split(",");
                for(let i in newImgs){
                    if(newImgs[i].indexOf('http')<0){
                        newImgs[i]=URL.imgUrl+newImgs[i];
                    }
                }
                good.goods_images = newImgs;
            }
            // 基础参数写入
            state.goods = good;
            state.spec_attr = attr1;
            state.color_attr = attr3;
            state.personal = personal;
            state.brandId = good.brand_id;
            state.brandName = good.brand_name;

            // 其它参数写入
            let newPrice = 0;
            // 价格
            if(!!personal.personal_price){
                newPrice = personal.personal_price;
            }else{
                newPrice = good.shop_price;
            }
            this.commit("setPrice", newPrice);
            this.commit("setUnit", good.unit);
            this.commit("setMdimg", good.goods_images[0])
        },
		setSuccessively(state, arg){ // 顺序
            state.successively = arg;
			// console.log("顺序",state.successively)
        },
        setPrice(state, arg){ // 写入价格
            state.price = arg;
        },
        setUnit(state, arg){ // 写入单位
            state.unit = arg;
        },
        setMdimg(state, arg){ // 写入中图片
            state.mdImg = arg;
        },
        setSpec(state, arg){ // 写入选中规格
            state.selected_spec = arg;
        },
        setColor(state, arg){ // 写入选中颜色
            state.selected_color = arg;
        },
        setStock(state, arg){ // 写入库存
            state.goods.goods_number = arg;
        },
        clearPdetail(state){ // 初始化详情页参数
            state.brandId = "";
            state.brandName = "";

            state.goods = {}; // 商品数据
            state.spec_attr = []; // 规格属性
            state.color_attr = []; // 颜色属性
            state.personal = {}; // 个人数据
    
            state.price = null; // 价格
            state.unit = null; // 单位
            state.mdImg = null; // 中图片地址
    
            state.selected_spec = null; // 选中规格
            state.selected_color = null; // 选中颜色
        },
        changePdetailCollection(state, arg){ // 修改详情页商品收藏状态
            state.goods.collection = arg
        },
        // 
        // ********* 首页管理 *************
        // 
        setCenterMainGoods(state, arg){ // 写入首页管理我的商品
            if(arg != []){
                for(let item of arg){ // 判断是否需要添加前缀
                    let newImgs = [];
                    newImgs=item.goods_images.split(",");
                    for(let i in newImgs){
                        if(newImgs[i].indexOf('http')<0){
                            newImgs[i]=URL.imgUrl+newImgs[i];
                        }
                    }
                    item.goods_images = newImgs
                }
            }
            state.center_mian_goods = arg;
        },
        // 
        // ********* 我的商品 *************
        // 
        setUserGoods(state, arg){ // 写入我的商品
            if(arg){
                for(let item of arg.data){ // 判断是否需要添加前缀
                    let newImgs = [];
                    newImgs=item.goods_images.split(",");
                    for(let i in newImgs){
                        if(newImgs[i].indexOf('http')<0){
                            newImgs[i]=URL.imgUrl+newImgs[i];
                        }
                    }
                    item.goods_images = newImgs
                }
                state.user_goods = arg.data;
                state.total = arg.total;
				state.per_page = arg.per_page;
                // 写入页码参数
                state.currentPage = arg.current_page;
                state.pageCount = arg.last_page;
            }else{ // 清空数据
                state.user_goods = [];
                state.currentPage = 1;
                state.pageCount = 1;
            }
        },
        handleUserGoodsCollection(state, arg){
            for(let item of state.user_goods){
                if(item.goods_id == arg.id){
                    item.collection = arg.status;
                }
            }
        },
        // 
        // ********* 收藏夹 *************
        // 
        setCollection(state, arg){ // 写入我的收藏
            if(arg){
                for(let item of arg.data){ // 判断是否需要添加前缀
                    let newImgs = [];
                    newImgs=item.goods_images.split(",");
                    for(let i in newImgs){
                        if(newImgs[i].indexOf('http')<0){
                            newImgs[i]=URL.imgUrl+newImgs[i];
                        }
                    }
                    item.goods_images = newImgs
                }
                state.collection_goods = arg.data;
                // 写入页码参数
                state.currentPage = arg.current_page;
                state.pageCount = arg.last_page;
				state.goods_per_page = arg.per_page;
				state.goods_total = arg.total;
            }else{ // 清空数据
                state.collection_goods = [];
                state.currentPage = 1;
                state.pageCount = 1;
            }
        }
    },
    actions: {
        // ********* 首页 *************
        //
        getMainGoods({ commit }){ // 获取首页商品
            let url = "/index/index/goodslist?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setMainGoods", res.data)
                }
            }).catch(() => {})
        },
        getTabsGoods({ commit }, arg){ // 标签页切换请求
            let { id, num } = arg, m = "", c = "",
            url = "/index/index/goods_child?lang="+lang+"&id="+id;
            switch(num) {
                case "2":
                    m = "changeSecondList";
                    c = "clearSecondList"
                    break
                case "3":
                    m = "changeThirdList";
                    c = "clearThirdList";
                    break
                case "4":
                    m = "changeFourthList";
                    c = "clearFourthList";
                    break
            }
            commit(c);
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    // 判断是否需要添加前缀
                    for(var item of res.data.list){
                        let newImgs = [];
                        newImgs=item.goods_images.split(",");
                        for(var i in newImgs){
                            if(newImgs[i].indexOf('http')<0){
                                newImgs[i]=URL.imgUrl+newImgs[i];
                            }
                        }
                        item.goods_images = newImgs;
                    }
                    commit( m, res.data.list );
                }
            }).catch(() => {})
        },
        // 
        // ********* 列表页 *************
        // 
        getBreadCrumb({ commit }, arg){ // 获取面包屑导航参数
            commit("clearBreadCrumb");
            if(!!arg){
                let id = arg,
                url = "/index/header/bread?lang="+lang+"&id="+id;
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setBreadCrumb", res.data.cate)
                    }
                }).catch(() => {})
            }
        },
        getSubcateBrand({ commit }, { id, search, brand, priority }){ // 获取子类列表 和 品牌数据
            commit("clearSubcateBrand");
            let c_url = `/index/index/cate?lang=${lang}&id=${id}&search=${search}&brand_id=${brand}&priority=${priority}`,
                b_url = `/index/goodslist/brand?lang=${lang}&id=${id}&search=${search}&brand_id=${brand}&priority=${priority}`;
            
            axios.get(c_url).then((res) => { // 子类列表
                if(res.data.code == 1){
                    commit("setSubcate", res.data.categorylist);
                }
            }).catch(() => {})
            axios.get(b_url).then((res) => { // 品牌数据
                if(res.data.code == 1){
                    commit("setBrand", res.data.brand)
                }
            }).catch(() => {})
        },
        getPlist({ commit, dispatch }, arg){ // 获取商品列表
            // 加载动画开启
            commit("handleLoading", true);
            // 清空数据
            commit("clearPlist")

            let url = "/index/search/search",
            num_url = "/index/search/number?lang="+lang,
            user_id = "", data = "";
            let { id, brand, search, priority, sort = "desc", number = "", page = "" } = arg;

            sort = sort? sort: "desc";
            // 从仓库获取参数
            if(this.state.user.islogin) // 如果登录
                user_id = this.state.user.user_info.id;
            data = qs.stringify({
                lang,
                id,
                user_id,
                brand,
                sort,
                search,
                priority,
                page,
                number
            })

            axios({ // 请求商品
                method: "POST",
                url,
                data
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setPlist", res.data)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取商品列表接口异常：${err}，请联系管理员`);
            })

            axios.get(num_url).then((res) => { // 页码数组
                if(res.data.code == 1){
                    commit("setPageSizes", res.data.number);
                }
            }).catch(() => {})
        },
        // 
        // ********* 详情页 *************
        // 
        getPdetail({ rootState, commit }, arg){
            commit("clearPdetail"); // 清除参数
            commit("handleLoading", true); // 加载动画开启
            let id = rootState.user.user_info.id || null,
            url = "/index/detail/detail?lang="+lang+"&goods_id="+arg+"&user_id="+id;
            axios.get(url).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setPdetail", res.data)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取商品详情接口异常：${err}，请联系管理员`);
            })
        },
        getAttrImg({ commit }, arg){
            commit("setMdimg", "");
            let url = "/index/detail/attr?goods_attr_id="+arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setStock", res.data.attr.attr_number)
                    if(res.data.attr.goods_images){
                        commit("setMdimg", res.data.attr.goods_images);
                    }else{
                        commit("setMdimg","https://www.newfaststationery.com/img/noimage.jpg")
                    }
                }
            }).catch(() => {})
        },

        requestCollection({ rootState }, arg){ // 收藏请求
            if(!rootState.user.islogin) return;
            return new Promise((resolve) => {
                let { goods_id, goods_sn, goods_name } = arg,
                user_id = rootState.user.user_info.id,
                url = "/index/goodslist/collection",
                data = qs.stringify({
                    user_id,
                    goods_id,
                    goods_sn,
                    goods_name
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(1)
                    }else if(res.data.code == 3){
                        resolve(3)
                    }
                }).catch(err => {
                    alert(`收藏接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ********* 首页管理 *************
        // 
        getCenterMainGoods({ rootState, commit }){ // 获取首页管理-我的商品
            commit("setCenterMainGoods", []);
            return new Promise((resolve) => {
                let islogin = rootState.user.islogin,
                company_id = rootState.user.user_info.company_id,
                url = "/index/information/personal?lang="+lang+"&company_id="+company_id;
                if(islogin && !!company_id){
                    axios.get(url).then((res) => {
                        if(res.data.code == 1){
                            commit("setCenterMainGoods", res.data.personal);
                            resolve(true)
                        }
                    }).catch(err => {
                        alert(`获取'首页管理-我的商品'接口异常：${err}，请联系管理员`);
                    })
                }
            })
        },
		getsuccessively({ commit }, arg){
			commit("setSuccessively", arg);
		},
        // 
        // ********* 我的商品 *************
        // 
        getUserGoods({ rootState, commit }, arg){ // 获取我的商品
            commit("setUserGoods", false);
            commit("handleLoading", true); // 加载动画开启
            let { 
                id = '', 
                brand = '', 
                sort = '', 
                page, 
                search = '' ,
				successively=''
            } = arg,
            islogin = rootState.user.islogin,
            company_id = rootState.user.user_info.company_id,
            url = "/index/mine/mine?lang="+lang+"&company_id="+company_id+"&id="+id+"&successively="+successively+"&brand="+brand+"&sort="+sort+"&page="+page+"&search="+search;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setUserGoods", res.data.personal);
                        commit("handleLoading", false); // 加载动画关闭
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`获取'我的商品'接口异常：${err}，请联系管理员`);
                })
            }
        },
        getUserGoodsBrand({ commit }, arg){ // 获取我的商品品牌
            commit("clearSubcateBrand");
            let c_url = "/index/index/cate?lang="+lang+"&id="+arg.id+"&brand_id="+arg.brand,
            b_url = "/index/mine/brand?lang="+lang+"&id="+arg.id+"&brand_id="+arg.brand;
            
            axios.get(c_url).then((res) => { // 子类列表
                if(res.data.code == 1){
                    commit("setSubcate", res.data.categorylist);
                }
            }).catch(() => {})
            axios.get(b_url).then((res) => { // 品牌数据
                if(res.data.code == 1){
                    commit("setBrand", res.data.brand)
                }
            }).catch(() => {})
        },
        // 
        // ********* 收藏夹 *************
        // 
        getCollection({ rootState, commit }, arg){ // 获取我的收藏
            commit("setCollection", false);
            commit("handleLoading", true); // 加载动画开启
            let { page, search } = arg,
			type = arg.type || 1,
            islogin = rootState.user.islogin,
			power = arg.power,
			url = ""
			if(power){
				url = "/index/collection/collection_list?lang=" + lang + "&search=" + search + "&page=" + page;	
			}else{
				url = "/index/collection/collection_list?lang=" + lang + "&search=" + search + "&page=" + page + "&type=" + type;	
			}
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setCollection", res.data.goods);
						
                    }
                }).catch(err => {
                    alert(`获取我的收藏接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            }
        },
        handleCollectBatch({}, { url, params }) {
            return axios({
                method: 'POST',
                url,
                data: params
            })
        }
    }
}